<template>
  <div id="app" class="guide-utilisateur">
    <section v-if="apiReady" class="has-bg-light">
      <my-header :logo-src="logoSrc"></my-header>
      <my-searchbar></my-searchbar>
      <div class="container">
        <div class="columns">
          <my-navbar></my-navbar>
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </section>
    <section v-else>
      <div class="container">
        <div class="columns">
          <div class="column is-offset-5" style="padding-top: 200px">
            <pulse-loader></pulse-loader>
          </div>
        </div>
      </div>
    </section>
    <my-footer></my-footer>
  </div>
</template>


<script>
  import { isNil } from 'lodash'
  import { api } from './cmsApi'
  import './styles/css/app.css'
  import './styles/wp_styles/wp-block-library/style.min.css'
  import './styles/wp_styles/template_style.css'
  import MyHeader from './components/MyHeader'
  import MySearchbar from './components/MySearchbar'
  import MyNavbar from './components/MyNavbar'
  import MyFooter from './components/MyFooter'
  import { mapState } from 'vuex'
  import PulseLoader from 'vue-spinner/src/PulseLoader'

  export default {
    name: 'App',
    components: { PulseLoader, MyFooter, MyNavbar, MySearchbar, MyHeader },
    data () {
      return {
        host: null,
        menuEntries: [],
        footerMenuEntries: [],
        topics: [],
        logoSrc: ''
      }
    },
    computed: {
      ...mapState(['apiReady'])
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
        await api.init()

        this.$store.commit('setApiReady', { apiReady: true })

        // let topics = await api.fetchContents('topic')
        // let pages = await api.fetchContents('page')
        // let pages = await api.fetchWPContents('pages')

        /*
        for (let topic of topics) {
          let pageIds = topic.data.pages.filter(p => p.page.isBroken === false).map(p => p.page.id)
          let topicPages = []
          for (let pageId of pageIds) {
            let page = pages.find(p => p.id === pageId)
            if (isNil(page)) {
              continue
            }
            topicPages.push(page)
          }
          topic.pages = topicPages
        }
        */

        /*
        topics = topics.sort((a, b) => {
          return a.data.position - b.data.position
        })
        */

        //this.topics = Object.freeze(topics)
        // this.$store.commit('setTopics', { topics: this.topics })

        let menuEntries = await api.fetchMenu('principal')
        let footerMenuEntries = await api.fetchMenu('3') // id du menu dans wp

        let siteInfos = await api.fetchSiteInfos() // recupe le logo depuis wp

        this.logoSrc = siteInfos.data.logoSrc // 'https://faq.vadimm.fr/img/logo-vadimm.ee6d264f.png'  // todo - favicons et compagnie

        this.menuEntries = Object.freeze(menuEntries)
        this.$store.commit('setMenuEntries', { menuEntries: this.menuEntries })

        this.footerMenuEntries = Object.freeze(footerMenuEntries)
        this.$store.commit('setFooterMenuEntries', { footerMenuEntries: this.footerMenuEntries })

      }
    }
  }
</script>

<style lang="css" scoped>

  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
      opacity: 0
  }

</style>
